import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddPriceGroupMutationVariables = Types.Exact<{
  input: Types.AddPriceGroupInput;
}>;


export type AddPriceGroupMutation = { __typename?: 'Mutation', addPriceGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type DeletePriceGroupMutationVariables = Types.Exact<{
  input: Types.DeletePriceGroupInput;
}>;


export type DeletePriceGroupMutation = { __typename?: 'Mutation', deletePriceGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type SetDefaultGroupMutationVariables = Types.Exact<{
  input: Types.SetDefaultGroupInput;
}>;


export type SetDefaultGroupMutation = { __typename?: 'Mutation', setDefaultGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type UpdatePriceGroupMutationVariables = Types.Exact<{
  input: Types.UpdatePriceGroupInput;
}>;


export type UpdatePriceGroupMutation = { __typename?: 'Mutation', updatePriceGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type SetPriceGroupDerivationMutationVariables = Types.Exact<{
  input: Types.SetPriceGroupDerivationInput;
}>;


export type SetPriceGroupDerivationMutation = { __typename?: 'Mutation', setPriceGroupDerivation: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type SetPriceGroupOrderVolumeDiscountMutationVariables = Types.Exact<{
  input: Types.SetPriceGroupOrderVolumeDiscountInput;
}>;


export type SetPriceGroupOrderVolumeDiscountMutation = { __typename?: 'Mutation', setPriceGroupOrderVolumeDiscount: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type SetPriceGroupQualificationConditionsMutationVariables = Types.Exact<{
  input: Types.SetPriceGroupQualificationConditionsInput;
}>;


export type SetPriceGroupQualificationConditionsMutation = { __typename?: 'Mutation', setPriceGroupQualificationConditions: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type UpdatePriceLevelsMutationVariables = Types.Exact<{
  input: Types.UpdatePriceLevelsInput;
}>;


export type UpdatePriceLevelsMutation = { __typename?: 'Mutation', updatePriceLevels: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type MergePriceLevelMutationVariables = Types.Exact<{
  input: Types.MergePriceLevelInput;
}>;


export type MergePriceLevelMutation = { __typename?: 'Mutation', mergePriceLevel: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetPriceLevelsVolumePoolMutationVariables = Types.Exact<{
  input: Types.SetPriceLevelsVolumePoolInput;
}>;


export type SetPriceLevelsVolumePoolMutation = { __typename?: 'Mutation', setPriceLevelsVolumePool: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeletePriceLevelMutationVariables = Types.Exact<{
  input: Types.DeletePriceLevelInput;
}>;


export type DeletePriceLevelMutation = { __typename?: 'Mutation', deletePriceLevel: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeletePriceLevelsMutationVariables = Types.Exact<{
  input: Types.DeletePriceLevelsInput;
}>;


export type DeletePriceLevelsMutation = { __typename?: 'Mutation', deletePriceLevels: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type InactivatePriceGroupMutationVariables = Types.Exact<{
  input: Types.InactivatePriceGroupInput;
}>;


export type InactivatePriceGroupMutation = { __typename?: 'Mutation', inactivatePriceGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type ActivatePriceGroupMutationVariables = Types.Exact<{
  input: Types.ActivatePriceGroupInput;
}>;


export type ActivatePriceGroupMutation = { __typename?: 'Mutation', activatePriceGroup: { __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, pricing?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null } };

export type BatchInactivatePriceGroupsMutationVariables = Types.Exact<{
  input: Types.BatchInactivatePriceGroupsInput;
}>;


export type BatchInactivatePriceGroupsMutation = { __typename?: 'Mutation', batchInactivatePriceGroups: { __typename?: 'PriceGroupBulkActionPayload', priceGroups?: Array<{ __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchActivatePriceGroupsMutationVariables = Types.Exact<{
  input: Types.BatchActivatePriceGroupsInput;
}>;


export type BatchActivatePriceGroupsMutation = { __typename?: 'Mutation', batchActivatePriceGroups: { __typename?: 'PriceGroupBulkActionPayload', priceGroups?: Array<{ __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BatchDeletePriceGroupsMutationVariables = Types.Exact<{
  input: Types.BatchDeletePriceGroupsInput;
}>;


export type BatchDeletePriceGroupsMutation = { __typename?: 'Mutation', batchDeletePriceGroups: { __typename?: 'PriceGroupBulkActionPayload', priceGroups?: Array<{ __typename?: 'PriceGroupPayload', errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string, recordId?: string | null, recordKind: Types.RecordKind, inUseBreakdown: Array<{ __typename?: 'InUseCount', kind: Types.InUseKind, count: number }> }> | null } };

export type AdjustPriceLevelsMutationVariables = Types.Exact<{
  input: Types.AdjustPriceLevelsInput;
}>;


export type AdjustPriceLevelsMutation = { __typename?: 'Mutation', adjustPriceLevels: { __typename?: 'AdjustPriceLevelsPayload', results: Array<{ __typename?: 'AdjustedPriceLevelData', priceLevelId: string, successorPriceLevelId: string, field: Types.PriceLevelPriceField, oldPrice?: number | null, newPrice?: number | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddPriceGroupDocument = new TypedDocumentString(`
    mutation AddPriceGroup($input: AddPriceGroupInput!) {
  addPriceGroup(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const DeletePriceGroupDocument = new TypedDocumentString(`
    mutation DeletePriceGroup($input: DeletePriceGroupInput!) {
  deletePriceGroup(input: $input) {
    errors {
      ...RecordValidationError
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}
fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const SetDefaultGroupDocument = new TypedDocumentString(`
    mutation SetDefaultGroup($input: SetDefaultGroupInput!) {
  setDefaultGroup(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const UpdatePriceGroupDocument = new TypedDocumentString(`
    mutation UpdatePriceGroup($input: UpdatePriceGroupInput!) {
  updatePriceGroup(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const SetPriceGroupDerivationDocument = new TypedDocumentString(`
    mutation SetPriceGroupDerivation($input: SetPriceGroupDerivationInput!) {
  setPriceGroupDerivation(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const SetPriceGroupOrderVolumeDiscountDocument = new TypedDocumentString(`
    mutation SetPriceGroupOrderVolumeDiscount($input: SetPriceGroupOrderVolumeDiscountInput!) {
  setPriceGroupOrderVolumeDiscount(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const SetPriceGroupQualificationConditionsDocument = new TypedDocumentString(`
    mutation SetPriceGroupQualificationConditions($input: SetPriceGroupQualificationConditionsInput!) {
  setPriceGroupQualificationConditions(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const UpdatePriceLevelsDocument = new TypedDocumentString(`
    mutation UpdatePriceLevels($input: UpdatePriceLevelsInput!) {
  updatePriceLevels(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const MergePriceLevelDocument = new TypedDocumentString(`
    mutation MergePriceLevel($input: MergePriceLevelInput!) {
  mergePriceLevel(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const SetPriceLevelsVolumePoolDocument = new TypedDocumentString(`
    mutation SetPriceLevelsVolumePool($input: SetPriceLevelsVolumePoolInput!) {
  setPriceLevelsVolumePool(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const DeletePriceLevelDocument = new TypedDocumentString(`
    mutation DeletePriceLevel($input: DeletePriceLevelInput!) {
  deletePriceLevel(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const DeletePriceLevelsDocument = new TypedDocumentString(`
    mutation DeletePriceLevels($input: DeletePriceLevelsInput!) {
  deletePriceLevels(input: $input) {
    errors {
      code
      message
    }
  }
}
    `);
export const InactivatePriceGroupDocument = new TypedDocumentString(`
    mutation InactivatePriceGroup($input: InactivatePriceGroupInput!) {
  inactivatePriceGroup(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const ActivatePriceGroupDocument = new TypedDocumentString(`
    mutation ActivatePriceGroup($input: ActivatePriceGroupInput!) {
  activatePriceGroup(input: $input) {
    errors {
      code
      message
    }
    pricing {
      ...PriceGroupStateData
    }
  }
}
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`);
export const BatchInactivatePriceGroupsDocument = new TypedDocumentString(`
    mutation BatchInactivatePriceGroups($input: BatchInactivatePriceGroupsInput!) {
  batchInactivatePriceGroups(input: $input) {
    priceGroups {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchActivatePriceGroupsDocument = new TypedDocumentString(`
    mutation BatchActivatePriceGroups($input: BatchActivatePriceGroupsInput!) {
  batchActivatePriceGroups(input: $input) {
    priceGroups {
      errors {
        code
        message
      }
    }
    errors {
      code
      message
    }
  }
}
    `);
export const BatchDeletePriceGroupsDocument = new TypedDocumentString(`
    mutation BatchDeletePriceGroups($input: BatchDeletePriceGroupsInput!) {
  batchDeletePriceGroups(input: $input) {
    priceGroups {
      errors {
        ...RecordValidationError
      }
    }
    errors {
      ...RecordValidationError
    }
  }
}
    fragment RecordValidationError on ValidationError {
  code
  message
  recordId
  recordKind
  inUseBreakdown {
    kind
    count
  }
}`);
export const AdjustPriceLevelsDocument = new TypedDocumentString(`
    mutation AdjustPriceLevels($input: AdjustPriceLevelsInput!) {
  adjustPriceLevels(input: $input) {
    results {
      ...AdjustedPriceLevel
    }
    errors {
      code
      message
    }
  }
}
    fragment AdjustedPriceLevel on AdjustedPriceLevelData {
  priceLevelId
  successorPriceLevelId
  field
  oldPrice
  newPrice
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddPriceGroup: build.mutation<AddPriceGroupMutation, AddPriceGroupMutationVariables>({
      query: (variables) => ({ document: AddPriceGroupDocument, variables })
    }),
    DeletePriceGroup: build.mutation<DeletePriceGroupMutation, DeletePriceGroupMutationVariables>({
      query: (variables) => ({ document: DeletePriceGroupDocument, variables })
    }),
    SetDefaultGroup: build.mutation<SetDefaultGroupMutation, SetDefaultGroupMutationVariables>({
      query: (variables) => ({ document: SetDefaultGroupDocument, variables })
    }),
    UpdatePriceGroup: build.mutation<UpdatePriceGroupMutation, UpdatePriceGroupMutationVariables>({
      query: (variables) => ({ document: UpdatePriceGroupDocument, variables })
    }),
    SetPriceGroupDerivation: build.mutation<SetPriceGroupDerivationMutation, SetPriceGroupDerivationMutationVariables>({
      query: (variables) => ({ document: SetPriceGroupDerivationDocument, variables })
    }),
    SetPriceGroupOrderVolumeDiscount: build.mutation<SetPriceGroupOrderVolumeDiscountMutation, SetPriceGroupOrderVolumeDiscountMutationVariables>({
      query: (variables) => ({ document: SetPriceGroupOrderVolumeDiscountDocument, variables })
    }),
    SetPriceGroupQualificationConditions: build.mutation<SetPriceGroupQualificationConditionsMutation, SetPriceGroupQualificationConditionsMutationVariables>({
      query: (variables) => ({ document: SetPriceGroupQualificationConditionsDocument, variables })
    }),
    UpdatePriceLevels: build.mutation<UpdatePriceLevelsMutation, UpdatePriceLevelsMutationVariables>({
      query: (variables) => ({ document: UpdatePriceLevelsDocument, variables })
    }),
    MergePriceLevel: build.mutation<MergePriceLevelMutation, MergePriceLevelMutationVariables>({
      query: (variables) => ({ document: MergePriceLevelDocument, variables })
    }),
    SetPriceLevelsVolumePool: build.mutation<SetPriceLevelsVolumePoolMutation, SetPriceLevelsVolumePoolMutationVariables>({
      query: (variables) => ({ document: SetPriceLevelsVolumePoolDocument, variables })
    }),
    DeletePriceLevel: build.mutation<DeletePriceLevelMutation, DeletePriceLevelMutationVariables>({
      query: (variables) => ({ document: DeletePriceLevelDocument, variables })
    }),
    DeletePriceLevels: build.mutation<DeletePriceLevelsMutation, DeletePriceLevelsMutationVariables>({
      query: (variables) => ({ document: DeletePriceLevelsDocument, variables })
    }),
    InactivatePriceGroup: build.mutation<InactivatePriceGroupMutation, InactivatePriceGroupMutationVariables>({
      query: (variables) => ({ document: InactivatePriceGroupDocument, variables })
    }),
    ActivatePriceGroup: build.mutation<ActivatePriceGroupMutation, ActivatePriceGroupMutationVariables>({
      query: (variables) => ({ document: ActivatePriceGroupDocument, variables })
    }),
    BatchInactivatePriceGroups: build.mutation<BatchInactivatePriceGroupsMutation, BatchInactivatePriceGroupsMutationVariables>({
      query: (variables) => ({ document: BatchInactivatePriceGroupsDocument, variables })
    }),
    BatchActivatePriceGroups: build.mutation<BatchActivatePriceGroupsMutation, BatchActivatePriceGroupsMutationVariables>({
      query: (variables) => ({ document: BatchActivatePriceGroupsDocument, variables })
    }),
    BatchDeletePriceGroups: build.mutation<BatchDeletePriceGroupsMutation, BatchDeletePriceGroupsMutationVariables>({
      query: (variables) => ({ document: BatchDeletePriceGroupsDocument, variables })
    }),
    AdjustPriceLevels: build.mutation<AdjustPriceLevelsMutation, AdjustPriceLevelsMutationVariables>({
      query: (variables) => ({ document: AdjustPriceLevelsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddPriceGroupMutation, useDeletePriceGroupMutation, useSetDefaultGroupMutation, useUpdatePriceGroupMutation, useSetPriceGroupDerivationMutation, useSetPriceGroupOrderVolumeDiscountMutation, useSetPriceGroupQualificationConditionsMutation, useUpdatePriceLevelsMutation, useMergePriceLevelMutation, useSetPriceLevelsVolumePoolMutation, useDeletePriceLevelMutation, useDeletePriceLevelsMutation, useInactivatePriceGroupMutation, useActivatePriceGroupMutation, useBatchInactivatePriceGroupsMutation, useBatchActivatePriceGroupsMutation, useBatchDeletePriceGroupsMutation, useAdjustPriceLevelsMutation } = injectedRtkApi;
